// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  matchId: __t.string(),
  targetUnitId: __t.string(),
  orderType: __t.string(),
  targetX: __t.option(__t.f64()),
  targetY: __t.option(__t.f64()),
  facing: __t.option(__t.f64()),
  stance: __t.option(__t.string()),
  rangedStance: __t.option(__t.string()),
  radius: __t.option(__t.f64()),
  targetAttackUnitId: __t.option(__t.string()),
};
